export enum PaidStatus {
    NotPaid = 0,
    Paid = 1,
    PartialPaid = 2,
    NotPaidAndPartialPaid = 3
}